import { useState } from 'react';
import dayjs from 'dayjs';
import type { DashboardFilters } from './useDashboardStats';

type PresetType = number | 'year' | 'today' | 'yesterday' | '2m' | '3m' | '6m';

interface UseDashboardFiltersReturn {
  dateFrom: Date | null;
  dateTo: Date | null;
  sectorId: string;
  userId: string | null;
  activePreset: PresetType | null;
  setDateFrom: (date: Date | null) => void;
  setDateTo: (date: Date | null) => void;
  setSectorId: (id: string) => void;
  setUserId: (id: string | null) => void;
  handlePreset: (preset: PresetType) => void;
  handleApply: () => void;
}

export const useDashboardFilters = (
  onApply: (filters: DashboardFilters) => void
): UseDashboardFiltersReturn => {
  const [dateFrom, setDateFrom] = useState<Date | null>(
    dayjs().subtract(7, 'day').toDate()
  );
  const [dateTo, setDateTo] = useState<Date | null>(dayjs().toDate());
  const [sectorId, setSectorId] = useState<string>('');
  const [userId, setUserId] = useState<string | null>(null);
  const [activePreset, setActivePreset] = useState<PresetType | null>(7);

  const handlePreset = (preset: PresetType) => {
    let from = dayjs();
    const to = dayjs();

    if (preset === 'today') {
      from = dayjs();
    } else if (preset === 'yesterday') {
      from = dayjs().subtract(1, 'day');
    } else if (preset === 'year') {
      from = dayjs().subtract(1, 'year');
    } else if (preset === '2m') {
      from = dayjs().subtract(2, 'month');
    } else if (preset === '3m') {
      from = dayjs().subtract(3, 'month');
    } else if (preset === '6m') {
      from = dayjs().subtract(6, 'month');
    } else {
      from = dayjs().subtract(preset, 'day');
    }

    setDateFrom(from.toDate());
    setDateTo(to.toDate());
    setActivePreset(preset);

    onApply({
      dateFrom: from.format('YYYY-MM-DD'),
      dateTo: to.format('YYYY-MM-DD'),
      sectorId: sectorId || undefined,
      attentionUserId: userId || undefined,
    });
  };

  const handleApply = () => {
    setActivePreset(null);
    onApply({
      dateFrom: dateFrom ? dayjs(dateFrom).format('YYYY-MM-DD') : undefined,
      dateTo: dateTo ? dayjs(dateTo).format('YYYY-MM-DD') : undefined,
      sectorId: sectorId || undefined,
      attentionUserId: userId || undefined,
    });
  };

  return {
    dateFrom,
    dateTo,
    sectorId,
    userId,
    activePreset,
    setDateFrom,
    setDateTo,
    setSectorId,
    setUserId,
    handlePreset,
    handleApply,
  };
};
